"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPropertyNameProperty = exports.propertyNamePropertyDefinition = void 0;
exports.propertyNamePropertyDefinition = {
    view: { label: 'Name' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'property-name',
};
const isPropertyNameProperty = (prop) => {
    return prop.name === exports.propertyNamePropertyDefinition.name;
};
exports.isPropertyNameProperty = isPropertyNameProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvcGVydHktbmFtZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Byb3BlcnR5LW5hbWUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFO0lBQ3ZCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxlQUFlO0NBQ1UsQ0FBQTtBQUkxQixNQUFNLHNCQUFzQixHQUFHLENBQUMsSUFBa0IsRUFBZ0MsRUFBRTtJQUN6RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssc0NBQThCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsc0JBQXNCLDBCQUVsQyJ9